import React, { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import Eyebrow from '../../../ui/Eyebrow';
import SearchField from '../../../ui/SearchField';

/**
 * `.locator-page-head` — eyebrow, `h1`, champ de recherche inline.
 *
 * La maquette n'avait ni titre dynamique ni recherche câblée. Le `h1` reprend
 * le nom de la ville : soit depuis `state.searchOrigin` (posé côté client
 * après une recherche), soit depuis le `search_shortcut` résolu côté serveur
 * pour `/location/:slug` — sinon le texte générique de la maquette.
 */
const HeroSearch = ({ slug, onSearch, onSelectPrediction, onGeolocate, isBusy }) => {
  const [state] = useContext(StateContext);
  const origin = state.searchOrigin;

  const shortcutLabel =
    !origin && slug ? (state.sl.search_shortcuts.find((shortcut) => shortcut.slug === slug) || {}).label : null;

  const cityLabel = (origin && origin.kind === 'city' && origin.label) || shortcutLabel;

  return (
    <div className="locator-page-head">
      <Eyebrow variant="pink">Trouver un salon</Eyebrow>
      <h1>
        {cityLabel ? (
          <>
            Nos salons <br />
            <span className="hl">à {cityLabel}</span>
          </>
        ) : (
          <>
            Tous nos salons <br />
            <span className="hl">près de vous</span>
          </>
        )}
      </h1>

      <SearchField
        variant="inline"
        onSearch={onSearch}
        onSelectPrediction={onSelectPrediction}
        onGeolocate={onGeolocate}
        isBusy={isBusy}
      />
    </div>
  );
};

export default HeroSearch;
